import Dashboard from './components/Dashboard.jsx';

function App() {
  return (
    <div className="min-h-screen bg-[#0f1214]">
      <Dashboard />
    </div>
  );
}

export default App;